import WebService from "../WebService";

const Event = {
  dashboard(data) {
    return WebService.post("/console/dashboard", data);
  },
  dashboardCompare(data) {
    return WebService.post("/console/dashboard/compare", data);
  },
  create(data) {
    return WebService.post("/events", data);
  },
  update(data) {
    return WebService.post("/events/" + data.e, data);
  },
  updateImage(formData, data) {
    return WebService.post("/events/" + data.e, formData);
  },
  updateCustomField(data) {
    return WebService.post("/events/" + data.e + "/fields", data);
  },
  updateSlug(data) {
    return WebService.post("/events/" + data.e + "/slug", data);
  },
  my(params) {
    return WebService.get("/my/events" + "?" + params);
  },
  myEventsWithoutDetail(params) {
    return WebService.get("/my/events-without-detail" + "?" + params);
  },
  gets(params) {
    return WebService.get("/events?" + params);
  },
  get(slug) {
    return WebService.get("/event/" + slug);
  },
  getProducts(slug) {
    return WebService.get("/event/" + slug + "/products?perPage=100");
  },
  getProductsInSeller(slug) {
    return WebService.get("/event/" + slug + "/products-in-seller?perPage=100");
  },
  getProduct(slug, product_id) {
    return WebService.get("/products/" + product_id + "?e=" + slug);
  },
  search(slug) {
    return WebService.get("/event/search?q=" + slug);
  },
  assignUser(data) {
    return WebService.post("/console/events/" + data.e + "/assign-user", data);
  },
  summary() {
    return WebService.get("/events/summary");
  },
  createVideo(params, data) {
    return WebService.post("video" + "?" + params, data);
  },
  updateVideo(params, data) {
    return WebService.post("video/" + data.id + "?" + params, data);
  },
  getVideo(id, params) {
    return WebService.get("video/" + id + "?" + params);
  },
  upload(e, data) {
    return WebService.post("/events/" + e + "/upload", data);
  },
  saveMerchant(data, e) {
    return WebService.post("/events/" + e + "/merchant", data);
  },
  checkEventName(data) {
    return WebService.post("/events/check/name", data);
  },
  updateEventDay(data, e) {
    return WebService.post("/events/" + e + "/save-event-day", data);
  },
  updateEventRole(data, e) {
    return WebService.post("/events/" + e + "/save-event-role", data);
  }
};
export default Event;
